<h2 mat-dialog-title class="admin-subheader">Abweichende Öffnungszeiten</h2>
<mat-dialog-content>
    <div [innerHTML]="data.notificationText" class="formatted-text"></div>
    <ul>
        @for(date of data.dates; track date) {
            <li>
                <div class="day-container">
                    <p class="custom-body-medium"><strong>{{ date.date }}:</strong></p>
                    @if(date.periods.length > 0){
                        @for(period of date.periods; track period) {
                            <p class="custom-body-medium">{{ period.open }} - {{ period.close }}</p>
                        }
                    }
                    @else {
                        <p class="custom-body-medium">Geschlossen</p>
                    }   
                </div>
            </li>
        }
    </ul>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="close()" cdkFocusInitial>Ok</button>
</mat-dialog-actions>
